import styled from 'styled-components';
import { Color } from '../../common/base';

const StatsWrapper = styled.div`
  background-color: ${Color.redMediumDark};
  padding: 60px 0;
  color: ${Color.white};
`;

export { StatsWrapper };
